<template>
    <div class="container">
        <div class="columns">
            <div class="column is-4">
                <div class="card">
<!--                    <div class="card-image">-->
<!--                        <figure class="image is-4by3">-->
<!--                            <img src="https://image.flaticon.com/icons/svg/149/149071.svg" alt="Placeholder image">-->
<!--                        </figure>-->
<!--                    </div>-->
                    <div class="card-content">
                        <div class="media">
                            <div class="media-left">
                                <figure class="image is-48x48">
                                    <img class="is-rounded" src="../../assets/svg/user_Logo.svg">
<!--                                    <img src="https://image.flaticon.com/icons/svg/149/149071.svg" alt="Placeholder image">-->
                                </figure>
                            </div>
                            <div class="media-content">
                                <p class="title is-4">{{user.full_name}}</p>
<!--                                <p class="subtitle is-6">@corendonairlines.com</p>-->
                            </div>
                        </div>

<!--                        <div class="content">-->
<!--                            {{user.full_name}}-->
<!--                            <hr>-->
<!--&lt;!&ndash;                            <time datetime="2016-1-1">11:09 PM - 1 Jan 2016</time>&ndash;&gt;-->
<!--                        </div>-->
                    </div>
                    <footer class="card-footer">

                    </footer>
                </div>
            </div>
            <div class="column is-8">
<!--                <file-pond name="file"-->
<!--                           ref="pond"-->
<!--                           label-idle="Edit profile picture"-->
<!--                           accepted-file-types="image/jpeg, image/png"-->
<!--                           :instant-upload="false"-->
<!--                           :drop-on-page="true"-->
<!--                           :allow-multiple="false"/>-->
<!--                <div class="title"><p>Your Permissions</p></div>-->
                <div class="title"><p>Your Permissions</p></div>
                <div class='list'>
                    <ul>
                        <div v-for="permission in filteredAllowedPermission" :key="permission.id" class='list-item'>
                            <li>
                                {{permission}}
                            </li>
                        </div>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // import vueFilePond from 'vue-filepond';
    // import FilePondPluginFileValidateType
    //     from 'filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type.esm.js';
    // import FilePondPluginImagePreview from 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.esm.js';

    import 'filepond/dist/filepond.min.css';
    import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
    import {mapState} from "vuex";

    // const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);

    export default {
        name: "UsersProfile",
        data() {
            return {
                file: ['camera.png'],
                userPermissions: this.$route.params.permissions,
            }
        },
        components: {
            // FilePond
        },
        computed: {
            ...mapState("auth", ["user"]),

            filteredAllowedPermission : function(){

               // return this.userPermissions.filter(i => this.userPermissions.find(j => j.id == i.id))
                return this.userPermissions.filter((item, index) => this.userPermissions.indexOf(item) === index);
            },

        },
        created() {
            // console.log(this.userPermissions.length)
        }
    }
</script>

<style scoped>

</style>
